import { isFedRamp } from '@atlassian/atl-context';
import { fg } from '@atlassian/jira-feature-gating';
/**
 * This checks if the current environment is FedRamp and returns false.
 * The FF is just a fail safe to not change existing behaviour.
 */
export const isCMDBEnabledInEnvironment = (): boolean =>
	!isFedRamp() || (isFedRamp() && fg('jsm-assets-fedramp-ui'));
